import { 
    SET_REPORT_LOADING, SET_NESTED_LOADING,
    GET_REPORT0_FAIL_REAL,CLEAR_STATE_REPORT0_REAL, GET_REPORT0_REAL,
    GET_REPORT0, GET_REPORT_FAIL0, CLEAR_STATE_REPORT0,
    GET_REPORT1, GET_REPORT_FAIL1, CLEAR_STATE_REPORT1, GET_CODE_1, GET_FAIL_CODE1,
    GET_REPORT2, GET_REPORT_FAIL2, CLEAR_STATE_REPORT2,
    GET_REPORT31, GET_REPORT_FAIL31, GET_CODE_31, GET_FAIL_CODE31, CLEAR_CODE31, CLEAR_STATE_REPORT31,
    GET_CODE_32, GET_FAIL_CODE32, CLEAR_CODE32, CLEAR_STATE_REPORT32, GET_REPORT32, GET_REPORT_FAIL32, 
    CLEAR_STATE_REPORT4, GET_REPORT_FAIL4, GET_REPORT4, GET_CODE4, GET_FAIL_CODE4, GET_FAIL_CODE4_NESTED, GET_CODE4_NESTED,
    GET_REPORT5, GET_REPORT_FAIL5, CLEAR_STATE_REPORT5, GET_CODE_5, GET_FAIL_CODE5,
    GET_REPORT6, GET_REPORT_FAIL6, CLEAR_STATE_REPORT6, GET_CODE_6, GET_FAIL_CODE6, GET_CODE_6_NESTED, GET_FAIL_CODE6_NESTED, SET_LOADING_NESTED6,
    GET_REPORT7, GET_REPORT_FAIL7, CLEAR_STATE_REPORT7,
    GET_REPORT8, GET_REPORT_FAIL8, CLEAR_STATE_REPORT8,
    GET_REPORT82, GET_REPORT_FAIL82, CLEAR_STATE_REPORT82,
    GET_REPORT9, GET_REPORT_FAIL9, CLEAR_STATE_REPORT9,
    GET_REPORT10, GET_REPORT_FAIL10, CLEAR_STATE_REPORT10
} from  '../actions/types'

const initialState = {
    error:null,
    reportLoading: false,
    nestedLoading: false,
    report0:null,
    error0:null,
    report0tree:null,
    error0tree:null,
    report1:null,
    error1:null,
    code1:null,
    report2:null,
    error2:null,
    report31:null,
    error31:null,
    code31:null,
    report32:null,
    code32:null,
    error32:null,
    report4:null,
    error4:null,
    report5:null,
    error5:null,
    code5:null,
    report6: null,
    code6:null,
    report7: null,
    report8: null,
    report82: null,
    report9: null,
    report10: null,
}

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_REPORT_LOADING:
            return {
                ...state,
                reportLoading: true,
                error: null
            }
        case SET_NESTED_LOADING:
            return {
                ...state,
                nestedLoading: true,
                error: null
            }
        case GET_REPORT0:
            return{
                ...state,
                report0: action.payload,
                reportLoading:false
            }
        case GET_REPORT_FAIL0:
            console.error(action.payload)
            return{
                ...state,
                error0:action.payload,
                reportLoading:false
            }
        case CLEAR_STATE_REPORT0:
            return{
                ...state,
                report0:null
            }
        ///do tree map nowy raport 0
        case GET_REPORT0_REAL:
            return{
                ...state,
                report0tree: action.payload,
                reportLoading:false
            }
        case GET_REPORT0_FAIL_REAL:
            console.error(action.payload)
            return{
                ...state,
                error0tree:action.payload,
                reportLoading:false
            }
        case CLEAR_STATE_REPORT0_REAL:
            return{
                ...state,
                report0tree:null
            }
        case GET_REPORT1:
            return{
                ...state,
                report1: action.payload,
                reportLoading:false
            }
        case GET_CODE_1:
            let codes1 = action.code.split('-')
            let temp1 = state.report1;
            temp1[codes1[0]]['children']=action.payload
            return{
                ...state,
                code1: action.payload,
                nestedLoading:false,
                report1:temp1
            }
        case CLEAR_STATE_REPORT1:
            return{
                ...state,
                report1:null
            }
        case GET_FAIL_CODE1:
            return{
                ...state,
                error1:action.payload,
                nestedLoading:false
            }
        case GET_REPORT_FAIL1:
            return{
                ...state,
                error1:action.payload,
                reportLoading:false
            }
        case GET_REPORT2:
            return{
                ...state,
                report2: action.payload,
                reportLoading:false
            }
        case GET_REPORT_FAIL2:
            return{
                ...state,
                error2:action.payload,
                reportLoading: false
            }
        case CLEAR_STATE_REPORT2:
            return{
                ...state,
                report2:null
            }
        case GET_REPORT31:
            return{
                ...state,
                report31: action.payload,
                reportLoading:false
            }
        case GET_FAIL_CODE31:
            return{
                ...state,
                error31:action.payload,
                nestedLoading:false
            }
        case GET_REPORT_FAIL31:
            return{
                ...state,
                error31:action.payload,
                reportLoading:false
            }
        case CLEAR_STATE_REPORT31:
            return{
                ...state,
                report31:null
            }
        case GET_CODE_31:
            let codes = action.code.split('-')
            let temp = state.report31;
            temp[codes[0]]['children']=action.payload
            return{
                ...state,
                code31: action.payload,
                nestedLoading:false,
                report31:temp
            }
        
        case GET_REPORT32:
            return{
                ...state,
                report32: action.payload,
                reportLoading:false
            }
        case GET_FAIL_CODE32:
            return{
                ...state,
                error32:action.payload,
                nestedLoading:false
            }
        case GET_REPORT_FAIL32:
            return{
                ...state,
                error32:action.payload,
                reportLoading:false
            }
        case CLEAR_STATE_REPORT32:
            return{
                ...state,
                report32:null
            }
        case GET_CODE_32:
            let codes32 = action.code.split('-')
            let temp32 = state.report32;
            temp32[codes32[0]]['children']=action.payload
                return{
                    ...state,
                    code32: action.payload,
                    nestedLoading:false,
                    report32:temp32
                }
        case GET_REPORT4:
            let temprep4 = action.payload;
            if(temprep4['nested']===undefined)temprep4['nested'] = {}
            return{
                ...state,
                report4: temprep4,
                reportLoading:false
            }
        case CLEAR_STATE_REPORT4:
            return{
                ...state,
                report4:null
            }
        case GET_CODE4:
            let codes4 = action.code
            let temp4 = state.report4?state.report4:{};
            if(temp4['nested']===undefined)temp4['nested'] = {}
            temp4['nested'][codes4]=action.payload
            return{
                ...state,
                nestedLoading: false,
                report4: temp4,
            }
        case GET_REPORT_FAIL4:
            return{
                ...state,
                reportLoading: false,
                error4:action.payload,
            }
        case GET_FAIL_CODE4_NESTED:
        case GET_FAIL_CODE4:
            return{
                ...state,
                nestedLoading: false,
                error4:action.payload,
            }
        case GET_CODE4_NESTED:
            let temp4nested = state.report4
            temp4nested.nested[action.active][action.code]['children']=action.payload
            return{
                ...state,
                report4: temp4nested,
                nestedLoading: false
            }
        case GET_REPORT5:
            return{
                ...state,
                report5: action.payload,
                reportLoading:false
            }
        case GET_REPORT_FAIL5:
            return{
                ...state,
                error5:action.payload,
                reportLoading:false
            }
        case GET_FAIL_CODE5:
            return{
                ...state,
                error5:action.payload,
                reportLoading:false
            }
        case CLEAR_STATE_REPORT5:
            return{
                ...state,
                report5:null
            }
        case GET_CODE_5:
            let codes5 = action.code.split('-')
            let temp5 = state.report5;
            temp5[codes5[0]]['children']=action.payload
            return{
                ...state,
                code5: action.payload,
                nestedLoading:false,
                report5:temp5
            }
        case GET_REPORT6:
            return{
                ...state,
                report6: action.payload,
                reportLoading:false
            }
        case CLEAR_STATE_REPORT6:
            return{
                ...state,
                report6:null
            }
        case GET_CODE_6:
            let temp6 = state.report6;
            temp6[action.category]['children']=action.payload
            return{
                ...state,
                code6: action.payload,
                nestedLoading:false,
                report6:temp6
            }
        case GET_CODE_6_NESTED:
            let temp6nested = state.report6;
            temp6nested[action.category]['children'][action.subcategory]['children']=action.payload
            return{
                ...state,
                report6: temp6nested,
                nestedLoading: false
            }
        case GET_REPORT_FAIL6:
            return{
                ...state,
                error:action.payload,
                reportLoading:false
            }
        case GET_FAIL_CODE6:
        case GET_FAIL_CODE6_NESTED:
            return{
                ...state,
                error:action.payload,
                nestedLoading:false
            }
        case GET_REPORT7:
            return{
                ...state,
                report7: action.payload,
                reportLoading:false
            }
        case GET_REPORT_FAIL7:
            return{
                ...state,
                error7:action.payload,
                reportLoading:false
            }
        case CLEAR_STATE_REPORT7:
            return{
                ...state,
                report7:null
            }
        case GET_REPORT8:
            return{
                ...state,
                report8: action.payload,
                reportLoading:false
            }
        case GET_REPORT_FAIL8:
            return{
                ...state,
                error8:action.payload,
                reportLoading:false
            }
        case CLEAR_STATE_REPORT8:
            return{
                ...state,
                report8:null
            }
        case GET_REPORT82:
            return{
                ...state,
                report82: action.payload,
                reportLoading:false
            }
        case GET_REPORT_FAIL82:
            return{
                ...state,
                error82:action.payload,
                reportLoading:false
            }
        case CLEAR_STATE_REPORT82:
            return{
                ...state,
                report82:null
            }
        case GET_REPORT9:
            return{
                ...state,
                report9: action.payload,
                reportLoading:false
            }
        case GET_REPORT_FAIL9:
            return{
                ...state,
                error9:action.payload,
                reportLoading:false
            }
        case CLEAR_STATE_REPORT9:
            return{
                ...state,
                report9:null
            }
        case GET_REPORT10:
            return{
                ...state,
                report10: action.payload,
                reportLoading:false
            }
        case GET_REPORT_FAIL10:
            return{
                ...state,
                error10:action.payload,
                reportLoading:false
            }
        case CLEAR_STATE_REPORT10:
            return{
                ...state,
                report10:null
            }
        default:
            return {...state}
    }
}